import {v4 as guid} from 'uuid';
import * as requestFromServer from './unpaidAgentsCrud';
import {
  unpaidAgentsSlice,
  callTypes
} from './unpaidAgentsSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';

export const getUnpaidAgentsListIDPrefix = 'getUnpaidAgentsList';
const {actions} = unpaidAgentsSlice;

const getUnpaidAgentsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getUnpaidAgentsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getUnpaidAgents(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalUnpaidAgentsCount: totalCount, pageCount, unpaidAgentsList}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: unpaidAgentsList
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find unpaid agents';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getUnpaidAgents = getUnpaidAgentsList(actions.unpaidAgentsFetched);
export const getNextUnpaidAgents = getUnpaidAgentsList(actions.unpaidAgentsAppended);

export const exportUnpaidAgentsFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getUnpaidAgentsFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.unpaidAgentsList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't get data!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const sendMessage = async (
  phone = '',
  email = '',
  message = ''
) => {
  try {
    const response = await requestFromServer.sendMessage(phone, email, message);
    const {errorCode} = response.data;
    if (errorCode !== 0) throw new Error();
  } catch (error) {
    console.error({error});
    error.clientMessage = 'Can\'t send message!';
  }
};